import { FC, Fragment, useReducer } from 'react';

import { useFormik } from 'formik';
import { Download } from 'lucide-react';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import { ExportPromoCodesForm } from './form';

import { promoCodeService } from 'v2/api/promoCodeService';
import { handleHttpError } from 'v2/utils';

export const ExportPromoCodesButton: FC = () => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('exportPromoCodes', promoCodeService.exportPromoCodes, {
    onSuccess: () => {
      handleClose();
    },
    onError: handleHttpError,
  });

  const formik = useFormik<ExportPromoCodesForm>({
    initialValues: { groupName: '' },
    onSubmit: (values) => {
      trigger(values.groupName);
    },
  });

  const handleClose = () => {
    formik.resetForm();
    setOpen();
  };

  return (
    <Fragment>
      <Button
        onClick={setOpen}
        loading={isMutating}
        startIcon={<Download width={20} height={20} />}
        variant="outlined"
        size="large"
      >
        Export
      </Button>

      <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Export Promo Codes</DialogTitle>

        <form onSubmit={formik.handleSubmit}>
          <DialogContent>
            <TextField
              name="groupName"
              value={formik.values.groupName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Group Name"
              required
              fullWidth
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} color="error" variant="outlined">
              Cancel
            </Button>

            <Button loading={isMutating} type="submit" variant="contained">
              Export
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </Fragment>
  );
};
